import { NavLink } from 'react-router'

import { TagColorDot } from '@/components/TagBadge'
import type { Doc } from '@repo/convex/dataModel'

type Tag = Doc<'hearsay_tags'>

const BASE = 'inline-flex items-center gap-1.5 rounded-md px-2.5 py-1 text-xs font-medium transition-colors'
const ACTIVE = 'bg-primary text-primary-foreground'
const INACTIVE = 'bg-muted text-muted-foreground hover:bg-muted/80'

export function TagFilterBar({ tags }: { tags: Tag[] }) {
	const rootTags = tags.filter((t) => !t.parentId)
	if (rootTags.length === 0) return null

	return (
		<div className="flex flex-wrap gap-1.5" role="navigation" aria-label="Filter by folder">
			<NavLink
				to="/"
				end
				className={({ isActive }) => `${BASE} ${isActive ? ACTIVE : INACTIVE}`}
			>
				All
			</NavLink>
			{rootTags.map((tag) => (
				<NavLink
					key={tag._id}
					to={`/tags/${tag._id}`}
					className={({ isActive }) => `${BASE} ${isActive ? ACTIVE : INACTIVE}`}
				>
					<TagColorDot color={tag.color} />
					{tag.name}
				</NavLink>
			))}
		</div>
	)
}
